export default __webpack_public_path__ + "static/media/bio_banner.630ebb46.png";